import { useState } from "react";
import { useAuth } from "zudoku/hooks";

const TOOLTIP_ID = "eam-login-tooltip";

export function EamLoginTooltip() {
  const { isAuthEnabled, isAuthenticated } = useAuth();
  const [visible, setVisible] = useState(false);

  // Only show when the Login button is visible
  if (!isAuthEnabled || isAuthenticated) return null;

  return (
    <div
      style={{ position: "relative", display: "flex", alignItems: "center", marginLeft: "-6px" }}
    >
      <button
        aria-label="EAM login information"
        aria-describedby={visible ? TOOLTIP_ID : undefined}
        onMouseEnter={() => setVisible(true)}
        onMouseLeave={() => setVisible(false)}
        onFocus={() => setVisible(true)}
        onBlur={() => setVisible(false)}
        style={{
          background: "none",
          border: "none",
          cursor: "pointer",
          padding: "4px",
          display: "flex",
          alignItems: "center",
          lineHeight: 0,
          color: "#4b3fff",
        }}
      >
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="16"
          height="16"
          viewBox="0 0 24 24"
          fill="none"
          stroke="currentColor"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
          aria-hidden="true"
          focusable="false"
        >
          <circle cx="12" cy="12" r="10" />
          <line x1="12" y1="16" x2="12" y2="12" />
          <line x1="12" y1="8" x2="12.01" y2="8" />
        </svg>
      </button>

      {visible && (
        <div
          id={TOOLTIP_ID}
          role="tooltip"
          style={{
            position: "absolute",
            top: "calc(100% + 8px)",
            right: 0,
            width: "220px",
            whiteSpace: "normal",
            backgroundColor: "#131517",
            color: "#FFFFFF",
            padding: "8px 12px",
            borderRadius: "6px",
            fontSize: "13px",
            lineHeight: "1.5",
            boxShadow: "0 4px 12px rgba(19, 21, 23, 0.15)",
            zIndex: 1000,
            pointerEvents: "none",
          }}
        >
          Using EAM APIs? No login needed — you're all set.
        </div>
      )}
    </div>
  );
}
